import type { TreeProps } from '@pega/cosmos-react-core';

export const themeToTree = (themeNode: object, parentPath?: string) => {
  const dataArray: TreeProps['nodes'] = [];
  Object.entries(themeNode).forEach(([childKey, childValue]) => {
    const id = parentPath ? `${parentPath}.${childKey}` : childKey;
    const label = childKey;

    // Is a leaf
    if (childValue.$type) {
      dataArray.push({
        id,
        label,
        data: { ...childValue }
      });
    }
    // Is a parent
    else {
      const nodes: TreeProps['nodes'] = themeToTree(childValue, id);
      dataArray.push({ id, label, nodes });
    }
  });

  return dataArray;
};
